import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaBriefcase, FaHandsHelping } from 'react-icons/fa';
import cvData from '../data/data.json';

const Experience = () => {
  const { workExperience, volunteerExperience } = cvData;

  const sectionStyle = {
    backgroundColor: '#0a192f',
    color: '#8892b0',
    padding: '5rem 0'
  };

  const headingStyle = {
    color: '#ccd6f6',
    marginBottom: '2rem',
    fontSize: '2rem',
    fontWeight: '600'
  };

  const cardStyle = {
    backgroundColor: '#112240',
    border: 'none',
    marginBottom: '1.5rem',
    transition: 'transform 0.3s ease'
  };

  const titleStyle = {
    color: '#ccd6f6',
    fontSize: '1.2rem',
    marginBottom: '0.5rem'
  };

  const badgeStyle = {
    backgroundColor: '#64ffda',
    color: '#0a192f',
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
    padding: '0.3rem 0.6rem',
    fontSize: '0.8rem',
    fontWeight: '500'
  };

  const neonTextStyle = {
    color: '#64ffda',
    textShadow: '0 0 5px rgba(100, 255, 218, 0.3)',
    fontSize: '1rem',
    lineHeight: '1.6'
  };

  const renderExperienceSection = (title, icon, experiences, renderItem) => (
    <div className="mb-5">
      <h2 style={headingStyle}>
        {icon} {title}
      </h2>
      {experiences.map((exp, index) => (
        <Card key={index} style={cardStyle} className="p-3">
          {renderItem(exp)}
        </Card>
      ))}
    </div>
  );

  return (
    <section style={sectionStyle}>
      <Container>
        <Row>
          <Col lg={12}>
            {renderExperienceSection('Work Experience', <FaBriefcase />, workExperience, (exp) => (
              <>
                <h3 style={titleStyle}>{exp.title}</h3>
                <p className="mb-2">
                  <strong style={{ color: '#64ffda' }}>{exp.company}</strong> - <span style={{ color: '#b5bcd1ff' }}>{exp.location}</span>
                </p>
                <p className="mb-2" style={{ color: '#8892b0' }}>{exp.period}</p>
                <div className="mb-3" style={neonTextStyle}>
                  {exp.description.split('. ').map((sentence, idx, arr) => (
                    sentence && (
                      <p key={idx} style={{ marginBottom: '0.5rem' }}>
                        • {sentence.trim()}{idx < arr.length - 1 ? '.' : ''}
                      </p>
                    )
                  ))}
                </div>
                <div>
                  {exp.technologies.map((tech, index) => (
                    <span key={index} style={badgeStyle}>{tech}</span>
                  ))}
                </div>
              </>
            ))}

            {renderExperienceSection('Volunteer Experience', <FaHandsHelping />, volunteerExperience, (exp) => (
              <>
                <h3 style={titleStyle}>{exp.title}</h3>
                <p className="mb-2">
                  <strong style={{ color: '#64ffda' }}>{exp.organization}</strong>
                </p>
                <p className="mb-2" style={{ color: '#8892b0' }}>{exp.period}</p>
                <div className="mb-3" style={neonTextStyle}>
                  {exp.description.split('. ').map((sentence, idx, arr) => (
                    sentence && (
                      <p key={idx} style={{ marginBottom: '0.5rem' }}>
                        • {sentence.trim()}{idx < arr.length - 1 ? '.' : ''}
                      </p>
                    )
                  ))}
                </div>
              </>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Experience; 